import Button from "@shared/ui/Button/Button";
import Modal from "@shared/ui/Modal/Modal";
import styles from "./ConfirmModal.module.scss";
import { useTranslation } from "react-i18next";
import DeleteIcon from "@shared/assets/icons/DeleteIcon";

const ConfirmModal = ({
  title,
  message,
  onConfirm,
  onCancel,
  confirmLabel,
  confirmVariant = "redBorder",
  cancelLabel,
}) => {
  const { t } = useTranslation();
  return (
    <Modal title={title} exit={onCancel}>
      <p>{message}</p>

      <div className={styles.buttons}>
        <Button variant="border" onClick={onCancel}>
          {cancelLabel ?? t("buttons.cancel")}
        </Button>
        <Button variant={confirmVariant} onClick={onConfirm}>
          {confirmVariant === "redBorder" && <DeleteIcon />}{" "}
          {confirmLabel ?? t("teamTable.delete")}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
